module.exports = __webpack_public_path__ + "static/media/iconjiantouxiajiang.b4becc27.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/iconjiantouxiajiang.png
// module id = 1976
// module chunks = 0